// Legacy flat keys still referenced by old i18n.t() calls. Machine-drafted — review before launch.
const legacyFr: Record<string, string> = {
	addteamMemberbtn: "Ajouter un membre de l'équipe",
	appsumo_code: 'Code AppSumo',
	card_delivered: 'Cette carte a déjà été livrée.',
	cards: 'Cartes',
	change_pass: 'Changer le mot de passe',
	confirm_pass: 'Confirmer le nouveau mot de passe',
	create_new_card: 'Créer une carte',
	draft: 'Brouillon',
	email: 'E-mail',
	enter_appsumo_code: 'Saisissez le code AppSumo',
	enter_email_address: 'Saisissez votre e-mail',
	firstName: 'Prénom',
	generate_card_preview: 'Veuillez patienter pendant la génération de l’aperçu de la carte',
	lastName: 'Nom',
	login: 'Connectez-vous à votre compte',
	logout: 'Se déconnecter',
	my: 'Mes',
	new_pass: 'Nouveau mot de passe',
	not_a_valid_file: 'Fichier non valide.',
	page_not_found_header: 'La page que vous recherchez est introuvable',
	page_not_found_para: 'Vous avez essayé une mauvaise route ou vous êtes arrivé ici par erreur. Quoi qu’il en soit, utilisez la navigation.',
	pricing: 'Tarifs',
	register: "S'inscrire",
	savebtn: 'Enregistrer',
	scheduled: 'Programmé',
	select_from_collection: 'Choisir dans la collection',
	updatebtn: 'Mettre à jour le profil',
	updateteamMemberbtn: 'Mettre à jour',
	upload_image: 'Importer une image',
	your_email_address: 'Adresse e-mail',
	checkout_desc_1: 'Choisissez l’un des designs illustrés de nos artistes comme couverture, ou créez le vôtre',
	checkout_desc_2: 'Concevez votre carte avec une collection de polices, de couleurs et de styles de texte, et importez vos propres images.',
	checkout_desc_3: 'Notre partage simple vous permet d’inviter tous ceux qui souhaitent participer à écrire un message',
	checkout_desc_4: 'Choisissez la date de cette livraison spéciale pour l’envoi automatique.',
	checkout_heading_1: 'Choisissez des designs illustrés',
	checkout_heading_2: 'Concevez et signez',
	checkout_heading_3: 'Collaborez et partagez',
	checkout_heading_4: 'Livraison automatique programmée',
};
export default legacyFr;
